import React, { useRef } from "react";
import { useClickOutsideBlock } from "../../helpers/useClickOutside";
import { LoaderSpinner } from "../LoaderSpinner";
import { SelectDropdown } from "../SelectDropdown";

export const BulkEditModal = ({
  isOpen,
  isLoading,
  onCancel,
  onSubmit,
  selectedCount = 0,
  actionValue = "READ",
  onActionChange,
  title = "Bulk Edit Notifications",
  size = "max-w-md",
  testId
}) => {
  const modalRef = useRef(null);
  useClickOutsideBlock(modalRef, () => {
    if (!isLoading) onCancel?.();
  });
  if (!isOpen) return null;

  return (
    <div
      aria-hidden="true"
      className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-40 justify-center items-center w-full md:inset-0 h-[calc(100%)] max-h-full"
      data-testid={testId}
    >
      <div className="bg-gray-700 top-0 right-0 left-0 fixed z-40 justify-center items-center w-full md:inset-0 h-[calc(100%)] max-h-full opacity-30" />
      <div
        ref={modalRef}
        className={`relative p-5 w-full ${size} max-h-full bg-white border top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 rounded-md`}
      >
        <h4 className="text-xl pb-4">{title}</h4>
        <div className="flex items-center gap-3">
          <div className="w-52">
            <SelectDropdown
              options={[
                { value: "READ", label: "Mark as Read" },
                { value: "UNREAD", label: "Mark as Unread" }
              ]}
              value={actionValue}
              onChange={onActionChange}
              selectClassname="!p-1.5"
            />
          </div>
          <span className="ml-auto text-sm text-gray-600">
            Selected: <span className="font-medium">{selectedCount}</span>
          </span>
        </div>
        <div className="flex justify-end gap-2 mt-6">
          <button
            onClick={onCancel}
            disabled={isLoading}
            className="min-w-20 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:mt-0 sm:w-auto sm:text-sm disabled:opacity-50"
          >
            {isLoading ? (
              <LoaderSpinner width="20" height="20" border="3" colorSpinner="gray" />
            ) : (
              "Cancel"
            )}
          </button>
          <button
            onClick={onSubmit}
            disabled={isLoading || selectedCount === 0}
            className="min-w-24 justify-center inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50"
          >
            {isLoading ? (
              <LoaderSpinner width="20" height="20" border="3" colorSpinner="white" />
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};


